import { useMemo } from "react";
import { useProjectPermissions } from "@/app/capabilities/api/hooks";
import { PROJECT } from "@/app/capabilities/permissions";
import { DataTable } from "@/components/custom/table/data-table";
import { DataTableContent } from "@/components/custom/table/data-table-content";
import { DataTablePagination } from "@/components/custom/table/data-table-pagination";
import type { ApiKeyItem } from "../../type";
import { getApiKeyColumns } from "./columns";
import { SearchToolbar } from "./search-toolbar";

type ApiKeysTableProps = {
  items: ApiKeyItem[];
  stickyColumnBg?: "card" | "background";
};

export const ApiKeysTable = ({
  items,
  stickyColumnBg = "background",
}: ApiKeysTableProps) => {
  const { canProject } = useProjectPermissions();
  const canRevoke = canProject(PROJECT.apiKeys.delete);
  const COLUMNS = useMemo(() => getApiKeyColumns(canRevoke), [canRevoke]);

  return (
    <DataTable
      className="my-4 space-y-4"
      columns={COLUMNS}
      data={items}
      defaultPageSize={10}
    >
      <SearchToolbar />
      <DataTableContent stickyColumnBg={stickyColumnBg} />
      <DataTablePagination />
    </DataTable>
  );
};
